<template>
    <div>
        <div
             class="bg-white
                        rounded-md
                        shadow
                        p-6
                        mb-4 print:-my-8 print:shadow-none">
            <h3 class="text-lg
                           mb-4">
                Gift Card Redemption Process
            </h3>
            <p>
                After 90 days of being an active customer with an account in "good standing", customer will receive an email directing them to claim their gift card through Customer Motivators.
                Email and landing page hosted by Customer Motivators. They will receive their gift card in a Breezeline branded envelope.
            </p>
        </div>
    </div>
</template>

<script>
import IconCheck from "@/atoms/icons/IconCheck"
export default {
    name: 'PromoInfo',
    components: {
        IconCheck,
    },
    props: {}
}
</script>

<style scoped>

</style>
